const fileUtil = {
  rename(originalFile, newFileName) {
    // Since it is not possible to change the name of a File object, we
    // copy the contents into a new File
    return new File([originalFile], newFileName, { type: originalFile.type });
  }
};

export default fileUtil;
